export interface GetUrlOptions {
  tenant: string | null;
}

export function getUrl<T>(
  url: string,
  options: GetUrlOptions,
  onSuccess: (result: T) => void,
  onError: (error: Error) => void,
): void {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.addEventListener('load', () => {
    if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText) {
      onSuccess(JSON.parse(xhr.responseText) as T);
    } else {
      onError(new Error(`${xhr.status}: ${xhr.statusText}`));
    }
  });
  xhr.addEventListener('error', () => {
    onError(new Error(`${xhr.status}: ${xhr.statusText}`));
  });

  if (options.tenant) {
    xhr.setRequestHeader('x-tenant-context', options.tenant);
  }

  xhr.send();
}
